import React, {useState, useContext, useRef, useEffect} from 'react';
import {TranslateContext} from "../../../../context/TranslateContext.jsx";
import {useHistory} from "react-router-dom";
import {LoaderContext} from "../../../../context/LoaderContext.jsx";
import {getBatchByIdApi} from "../../../../services/SchedulazioniServices";

export const useModificaBatch = ({idBatch}) => {

    const loader = useRef(useContext(LoaderContext));
    const {traduci} = useContext(TranslateContext);

    const [batch, setBatch] = useState(null);

    const formikRef = useRef();
    const history = useHistory();

    async function getBatchById() {
        loader.current.startChiamata();
        const response = await getBatchByIdApi(idBatch);
        setBatch(response.data.data);
        loader.current.endChiamata();
    }

    useEffect(() => {
        if (idBatch && idBatch !== '') {
            getBatchById();
        }
    }, [idBatch]);

    const getBottoniSx = () =>
        <button type="button" id="back" name="back"
                className="btn btn-card"
                onClick={() => {
                    history.goBack();
                }}>
            <i className="fas fa-angle-left"/>
        </button>

    const getBottoniDx = () =>
        <button type="button" id="salva" name="salva"
                className="btn btn-card"
                onClick={() => {
                    if (formikRef.current) {
                        formikRef.current.handleSubmit()
                    }
                }}>
            <i className="fas fa-save"/> <span className={'cmms-display-mobile'}>Salva</span>
        </button>

    const title = idBatch ? 'Modifica Batch' : 'Inserisci Batch';

    return {
        getBottoniSx,
        getBottoniDx,
        title,
        batch,
        formikRef,
    };
};
